import React from "react";
import S from "./CardHeader.styled";
import FundContext from "@/components/FundSingle/FundProvider";
import { useContext } from "react";

export interface CardHeader {
    title: string;
    subTitle?: string;
}

const CardHeader: React.FC<CardHeader> = ({ title, subTitle }) => {
    const {fundRiskDetails} = useContext(FundContext);

    return (
        <S.CardHeaderWrapper>
            <S.CardTitle>
                {title}
            </S.CardTitle>
            {subTitle && <S.CardSubTitle>
                {subTitle}
            </S.CardSubTitle>}
        </S.CardHeaderWrapper>
    );
};

export default CardHeader;
